<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { serviceType } from "../../../../../services/managements/services/servicetype.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Service List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        fetchingStats: false,
        title: "Service List",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
        this.fetchingStats = false;
            serviceType.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
            });
        },

        deleted: function(id) {
            serviceType.remove(id)
                .then(response => {
                // this.customerData = response;
                if(response.status == 200) {
                    this.$swal.fire({
                    title: i18n.t('general.confirm.deleted'),
                    text: i18n.t('general.confirm.success'),
                    icon: "success",
                    confirmButtonText: i18n.t('general.ok')
                    });
                }
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-service-type-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-service-type-add'}" :title="$t('manage.service.type')" />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('manage.service.name')}`,
            `name_en: ${$t('manage.name_en')}`,
          ]"
          v-bind:edit="{link: 'manage-setting-service-type-edit'}"
          v-bind:filter="{
            search: ['mg_service_types.name','mg_service_types.name_en']
          }"
          
    />      
  </Layout>
</template>